import styled from 'styled-components';
import { FeedsContainer } from '../../../Utils/styles/display';

export const FeedLoaderContainer = styled(FeedsContainer)`
  margin: 0 auto;
  max-width: 1062px;
`;
